import { Component } from '@theme/component';

const DESKTOP_MQ = '(min-width: 750px)';

class RhmBuyLook extends Component {
  #mq: MediaQueryList | null = null;
  #activeIndex = 0;

  connectedCallback() {
    super.connectedCallback();

    this.#mq = window.matchMedia(DESKTOP_MQ);
    this.#bindTriggers();
    this.#mq.addEventListener('change', this.#onMqChange);
    this.#setActive(this.#activeIndex);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#mq?.removeEventListener('change', this.#onMqChange);
    this.#mq = null;
  }

  #onMqChange = () => {
    this.#setActive(this.#activeIndex);
  };

  #bindTriggers() {
    const triggers = this.querySelectorAll<HTMLElement>('[data-buy-look-trigger]');

    for (const trigger of triggers) {
      trigger.addEventListener('click', this.#onTriggerActivate);
      trigger.addEventListener('pointerenter', this.#onPointerEnter);
      trigger.addEventListener('focusin', this.#onFocusIn);
    }
  }

  #onTriggerActivate = (event: Event) => {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement | null;
    if (!target) return;
    this.#activateFromTrigger(target);
  };

  #onPointerEnter = (event: Event) => {
    if (!this.#mq?.matches) return;
    const target = event.currentTarget as HTMLElement | null;
    if (!target) return;
    this.#activateFromTrigger(target);
  };

  #onFocusIn = (event: Event) => {
    const target = event.currentTarget as HTMLElement | null;
    if (!target) return;
    this.#activateFromTrigger(target);
  };

  #activateFromTrigger(trigger: HTMLElement) {
    const raw = trigger.dataset.buyLookIndex;
    if (raw == null) return;
    const index = Number.parseInt(raw, 10);
    if (Number.isNaN(index)) return;
    this.#setActive(index, { scroll: true });
  }

  #setActive(index: number, { scroll = false }: { scroll?: boolean } = {}) {
    this.#activeIndex = index;

    const cards = this.querySelectorAll<HTMLElement>('[data-buy-look-card]');
    for (const card of cards) {
      const cardIndex = Number.parseInt(card.dataset.buyLookCard ?? '', 10);
      const isActive = cardIndex === index;
      card.classList.toggle('is-active', isActive);
    }

    const markers = this.querySelectorAll<HTMLElement>('.buy-look-marker');
    for (const marker of markers) {
      const markerIndex = Number.parseInt(marker.dataset.buyLookIndex ?? '', 10);
      marker.classList.toggle('is-active', markerIndex === index);
    }

    if (!scroll || this.#mq?.matches) return;

    const activeCard = this.querySelector<HTMLElement>(`[data-buy-look-card="${index}"]`);
    activeCard?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

if (!customElements.get('rhm-buy-look')) {
  customElements.define('rhm-buy-look', RhmBuyLook);
}
